module.exports = __webpack_public_path__ + "static/media/individual.3bceb6ec.png";